const itemSstyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  border: "1px solid #ccc",
  borderRadius: "5px",
  padding: "20px",
  width: "50%",
  margin: "10px auto",
  backgroundColor: "#f9f9f9",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
};

const WaxItem = ({ item }) => {
  return (
    <div style={itemSstyle}>
      <div>
        <h3 className="massage-title">{item.title}</h3>
      </div>
      <h3>${item.price}</h3>
    </div>
  );
};

export default WaxItem;
